import { cmsGraphql } from '../lib/cms/index.js'

export const CmsMetaFragment = cmsGraphql(/* GraphQL */ `
  fragment CmsMetaFragment on CmsMeta {
    title
    image {
      ...CmsMediaFragment
    }
    description
    noIndex
    jsonLD
  }
`)
